<template>
    <div>
        <vForm :label-width="120" ref="form" class="margin-15 clearfix">
            <div class="clearfix" v-if="querytype!='query'">
                <vCol span="24" style="border-bottom: 1px dashed #d1d1d1;margin-bottom:15px;">
                    <vCol span="8">
                        <vFormItem :label="$t('fbb.truck.traynum', { defaultValue: '托盘数' })" :rules="required" prop="palletQty">
                            <span v-if="querytype=='query'">{{formData.palletQty}}</span>
                            <Input v-else v-model="formData.palletQty"></Input>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('fbb.truck.palletsize', { defaultValue: '托盘尺寸' }) + '(inch)'" :rules="required" prop="palletSize">
                            <span v-if="querytype=='query'">{{formData.palletSize}}</span>
                            <Input v-else v-model="formData.palletSize"></Input>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('fbb.truck.singleweight', { defaultValue: '单托重量' }) + '(lb)'" :rules="required" prop="weight">
                            <span v-if="querytype=='query'">{{formData.weight}}</span>
                            <Input v-else v-model="formData.weight"></Input>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('fbb.truck.productQty', { defaultValue: '产品数量' })" :rules="required" prop="productQty">
                            <span v-if="querytype=='query'">{{formData.productQty}}</span>
                            <Input v-else v-model="formData.productQty"></Input>
                        </vFormItem>
                    </vCol>
                    
                    <vCol span="8">
                        <vFormItem :label="$t('global.common.currency',{defaultValue:'币种'})" :rules="required" prop="currency">
                            <span v-if="querytype=='query'">{{formData.currency}}</span>
                            <vSelect v-else v-model="formData.currency">
                                <vOption v-for="json in getCurrencyList" :key="json" :value="json"></vOption>
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('erp.product.category_name',{defaultValue:'品名'})" :rules="required" prop="productName">
                            <span v-if="querytype=='query'">{{formData.productName}}</span>
                            <Input v-else v-model="formData.productName"></Input>
                        </vFormItem>
                    </vCol>
                </vCol>
                <vCol span="24" class="margin-top-15">
                    <vCol span="8">
                        <vFormItem label="Shipment ID" >
                            <span v-if="querytype=='query'">{{idsdata.shipmentId}}</span>
                            <Input v-else v-model="idsdata.shipmentId"></Input>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem label="Reference ID">
                            <span v-if="querytype=='query'">{{idsdata.removeOrderId}}</span>
                            <Input v-else v-model="idsdata.removeOrderId"></Input>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vButton v-if="querytype!='query'" theme="warning" @click="addOne" class="margin-bottom-10" style="margin-left:120px">{{$t('global.common.add', { defaultValue: "添加" })}}</vButton>
                        <vButton v-if="querytype!='query'" theme="success" class="margin-left-10" @click="importExcel">导入</vButton>
                    </vCol>
                </vCol>
            </div>
            <div class="clearfix" v-if="querytype=='query'">
                <vCol span="24">
                    <vCol span="8" >
                        <vFormItem :label="$t('fbb.headlogistics.total_weight', { defaultValue: '总重量' })+ '(lb)'" >
                            <span >{{allweightnum}}</span>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('fbb.logistics.total_number', { defaultValue: '总数量' })">
                            <span >{{allpronum}}</span>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('fbb.truck.total_traynum', { defaultValue: '总托盘数' })">
                            <span >{{alltraynum}}</span>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem label="Shipment ID" >
                            <span >{{idsdata.shipmentId}}</span>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem label="Reference ID">
                            <span >{{idsdata.removeOrderId}}</span>
                        </vFormItem>
                    </vCol>
                </vCol>
            </div>
            <vTable class="margin-top-15" :data="detailList" border stripe :columns="columnsList"></vTable>
            
        </vForm>
        <!-- 公共弹框 -->
        <compModal
			v-model="modalData.show"
			v-bind="modalData"
            @on-close="modalData={}"
		>
            <component ref="cusref" :is="modalData.component" v-bind="modalData" v-on="modalData.on" @on-close="modalData={}"></component>
        </compModal>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
    props:['detailList','idsdata','querytype'],
    components:{
        compUpload: () =>  import("@components/templates/upload"),
    },
    data(){
        return {
            formData:{
                currency:'USD'
            },
            modalData:{},
            required: [{
                required: true,
                message: this.$t('global.common.fill_requiredd',{defaultValue:'该信息不能为空,请填写'}),
            }],
        }
    },
    computed:{
        ...mapGetters('common', ['getCurrencyList']),
        allweightnum(){
            let num = 0;
            this.detailList.map(item=>{
                num += (item.weight * item.palletQty)
            })
            return num || 0
        },
        allpronum(){
            let num = 0;
            this.detailList.map(item=>{
                num += (item.productQty * item.palletQty)
            })
            return num || 0
        },
        alltraynum(){
            let num = 0;
            this.detailList.map(item=>{
                num += (item.palletQty)
            })
            return num || 0
        },
        columnsList(){
            return [
                {
                    title: 'No.',
                    type:"index",
                },
                {
                    title: this.$t('fbb.truck.traynum', { defaultValue: '托盘数' }),
                    key: "palletQty",
                },
                {
                    title: this.$t('fbb.truck.palletsize', { defaultValue: '托盘尺寸' })+'(inch)',
                    key: "palletSize",
                },
                {
                    title: this.$t('fbb.truck.singleweight', { defaultValue: '单托重量' })+'(lb)',
                    key: "weight",
                },
                {
                    title: this.$t('fbb.truck.productQty', { defaultValue: '产品数量' }),
                    key:"productQty",
                },
                {
                    title: this.$t('global.common.currency',{defaultValue:'币种'}),
                    key: "currency",
                },
                {
                    title: this.$t('erp.product.category_name',{defaultValue:'品名'}),
                    key: "productName",
                },
                {
					title: '操作',
                    width: this.querytype !='query' ? 120 : 0,
                    render:(h, { row, index })=>{
						return h('div', [
                            h('vButton', {
                                props: {
                                    theme: "error",
                                    size: 'small',
                                },
                                on: {
                                    click: () => {
                                        this.remove(index)
                                    }
                                },
                                style: {
                                    'margin-right': '15px'
                                }
                            }, '删除')
                        ])
					}
				}
            ]
        },
    },
    methods:{
        importExcel(){
            this.modalData = {
                show: true,
                title: '导入数据',
                width:460,
                showFooter: false,
                action: process.env.VUE_APP_APIURL_FBB + "/api/v2/truck/batchImport",
                name: "excelFile",
                component: "compUpload",
                download: () => {
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/truck/itemTemplate',{},'download')
                },
                on:{
                    'on-success':(res)=>{
                        this.detailList = res.data
                    }
                }
            }
        },
        addOne(){
            let datajson = {palletQty:this.formData.palletQty,
            palletSize:this.formData.palletSize,
            weight:this.formData.weight,
            productQty:this.formData.productQty,
            currency:this.formData.currency,
            productName:this.formData.productName}
            this.detailList.push(datajson);

            this.formData = {currency:'USD'}
        },
        remove(index){
            this.detailList.splice(index,1)
        }
    }
}
</script>
